// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2626":"92648958c7b8d202","2888":"b7140674d1a4c597"}[chunkId] + ".css";
};